import React from 'react';
import './Accreditations.css';
import { FaCertificate, FaCheckCircle } from 'react-icons/fa';

const Accreditations = () => {
  return (
    <section className="accreditations section">
      <div className="container">
        <h2 className="section-title">
          <span className="gradient-text">Accreditation</span> Support
        </h2>
        <p className="section-subtitle">
          Our solutions are designed to help healthcare facilities achieve and maintain 
          internationally recognized accreditation standards
        </p>

        <div className="accreditation-grid">
          <div className="accreditation-card">
            <div className="accreditation-icon">
              <FaCertificate />
            </div>
            <h3>NABH Accreditation</h3>
            <p>
              National Accreditation Board for Hospitals & Healthcare Providers compliance built-in. 
              Our software helps you meet all NABH standards with comprehensive documentation and tracking.
            </p>
            <ul className="accreditation-features">
              <li><FaCheckCircle /> Quality Management System</li>
              <li><FaCheckCircle /> Patient Safety Standards</li>
              <li><FaCheckCircle /> Infection Control Protocols</li>
              <li><FaCheckCircle /> Continuous Quality Improvement</li>
            </ul>
          </div>

          <div className="accreditation-card">
            <div className="accreditation-icon">
              <FaCertificate />
            </div>
            <h3>JCI Accreditation</h3>
            <p>
              Joint Commission International standards compliance to achieve global recognition. 
              Our platform supports all JCI requirements for international healthcare excellence.
            </p>
            <ul className="accreditation-features">
              <li><FaCheckCircle /> International Patient Safety Goals</li>
              <li><FaCheckCircle /> Care Continuum Standards</li>
              <li><FaCheckCircle /> Management Standards</li>
              <li><FaCheckCircle /> Comprehensive Documentation</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accreditations;
